import { useQuery } from '@tanstack/react-query'
import jsCookies from 'js-cookie'

import { BonhamsCookies, EBonhamsCookies } from '@nx/global-types'
import { getJWTExpiryFromCookieClient } from '@nx/helpers'

import { useGetUser } from '../../user/getUser/useGetUser'
import { getUserBids } from './getUserBids'

interface UseGetActiveBidProps {
  baseURL: string
}

export function useGetActiveBids({ baseURL }: UseGetActiveBidProps) {
  const { data: user } = useGetUser(baseURL)
  const tokenExpirationDateInSeconds = getJWTExpiryFromCookieClient(
    EBonhamsCookies.access
  )

  return useQuery({
    queryKey: ['activeBids', user?.customerId],
    queryFn: () => {
      const accessToken = jsCookies.get(EBonhamsCookies.access)
      const refreshToken = jsCookies.get(EBonhamsCookies.refresh)

      return getUserBids({
        baseURL,
        biddableLotsOnly: true,
        cancelled: false,
        page_size: 300,
        cookies: {
          bonhams_access: accessToken,
          bonhams_token: refreshToken,
        } as BonhamsCookies,
      })
    },
    enabled: !!user,
    staleTime:
      tokenExpirationDateInSeconds > 0
        ? Math.abs(tokenExpirationDateInSeconds * 1000 - Date.now())
        : 0,
  })
}
